const LOGIN_PUBLIC_KEY = ``;

// OSS地址
const ossDevPublicParams = {
  endpoint: "oss-cn-shanghai.aliyuncs.com",
  accessKeyId: "LTAI4FtPpWjBMBtNQRRf8qyk",
  accessKeySecret: "0U7b1BBjMgeCA20PVvZe0YHkPZHpA5"
};

const ossQYBLDev = {
  endpoint: "oss-cn-shanghai.aliyuncs.com",
  accessKeyId: "LTAI4FnZS4bxwQPkCUCLjDnE",
  accessKeySecret: "tKbZ5seFkf4PauKUDkyHkVDl43mmz5"
};
const ossQYBL = {
  endpoint: "oss-cn-shanghai.aliyuncs.com",
  accessKeyId: "LTAI4Fh6khFk8cLPGxRynXYu",
  accessKeySecret: " jjLuPSXv5l1E07CqY7TQxNStknISqI"
};

const config = {
  copyright:
    "© 2019 内蒙古庆源绿色金融资产管理有限公司. All rights reserved. 蒙ICP备18001640号-1 mail.greenamc.com",
  timeout: 30000,
  db_prefix: "as_",
  publicKey: LOGIN_PUBLIC_KEY,
  assetsPath: process.env.BASE_URL || "./",

  // 联系人
  telephones: [
    "0471-3149262",
    "15998951553",
    "18682100214",
    "15248062885"
  ],

  /**
   * OSS基本配置
   */
  ossCfg: {
    // 资产上传（测试环境）
    assetsDev: {
      ...ossDevPublicParams,
      bucket: "billtradecontract"
    },
    // 资产上传（正式环境）
    assets: {
      ...ossDevPublicParams,
      bucket: ""
    },

    // 担保物发布时上传的图片（测试环境）
    collateralDev: {
      ...ossDevPublicParams,
      bucket: "billtradecontract"
    },
    // 担保物发布时上传的图片（正式环境）
    collateral: {
      ...ossDevPublicParams,
      bucket: "billtradecontract"
    },

    // 注册上传
    registerDev: {
      ...ossQYBLDev,
      bucket: 'minxun-test'
    },
    // 注册上传
    register: {
      ...ossQYBL,
      bucket: 'qybl-regist'
    },

    // 图片识别
    ocrDev: {
      ...ossQYBLDev,
      bucket: 'minxun-test'
    },
    ocr: {
      ...ossQYBL,
      bucket: 'qybl-ocr'
    }
  }
};

export default config;
